module.exports = __webpack_public_path__ + "img/icon.9b463d56.jpg";